import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import './TabContent.css';
import TabGroup from './TabGroup.js';

// Provides the Content for a 'Category1' from the Subscription Categories
class TabContent extends PureComponent {

    static defaultProps = {
        
    };

    render() {

        const {
            data,
            params,
        } = this.props;

        const selectedHierarchy =  data.tabHierarchy.filter(item => item.category === data.selectedCategory1)[0];

        const tabGroups = 
            <TabGroup
                level={1}
                category={selectedHierarchy}
                key={selectedHierarchy.category}
                twoColumnLayout={params.twoColumnLayout}
            />;

        return (
            <div className='tab-content'>
                {tabGroups}
            </div>
        );
    }

}

function mapStateToProps(state) {
    return {
        data: state.data,
        params: state.params,
    };
}

export default connect(mapStateToProps,
    {
    })(TabContent);
